import { render, staticRenderFns } from "./repo_dropdown.vue?vue&type=template&id=2e210f13"
import script from "./repo_dropdown.vue?vue&type=script&lang=js"
export * from "./repo_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports